import React from 'react';
import { store } from '@risingstack/react-easy-state';
import request from '../helpers/request';

if (!sessionStorage.length) {
    sessionStorage.setItem('getSessionStorage', Date.now());
    sessionStorage.removeItem('getSessionStorage');
}

window.addEventListener('storage', (e) => {
    if (e.key === 'getSessionStorage') {
        sessionStorage.setItem('sessionStorage', JSON.stringify(sessionStorage))
        sessionStorage.removeItem('sessionStorage');
    } else if (e.key === 'sessionStorage' && !sessionStorage.length) {
        var data = JSON.parse(e.newValue);

        for (let key in data) {
            console.log(key, data[key]);
            sessionStorage.setItem(key, data[key]);
        }

        session.fetch();
        window.location.href = window.location.search.split('?')[1];
    }
});

const session = store({
    token: sessionStorage.getItem('user-token'),
    user: {
        id: null,
        name: null,
        permissions: [],
        bookmarks: []
    },
    company: {
        login_video_url: '',
        vca_video_url: '',
        can_azure_login: false
    },
    wholesaler: null,
    retailer: null,
    product_type_access: null,
    fetch: () => {
        return request(true).get('/self').then(e => {
            console.log('fetched');
            session.user.id = e.data.id;
            session.user.name = e.data.name;
            session.user.permissions = e.data.permissions.map(function (item) {
                return item.key;
            });
            session.user.bookmarks = e.data.bookmarks.sort((a, b) => 
                (a.order - b.order + e.data.bookmarks.length) % e.data.bookmarks.length
            );
            session.user.user_type = e.data.user_type;
            session.company = e.data.company;
            session.wholesaler = e.data.wholesaler;
            session.retailer = e.data.retailer;
            session.product_type_access = e.data.product_type_access;
            console.log(e.data.company);
            return;
        }).catch(e => {
            console.log(e);
            const response = e.response ?? e;

            const isStatus503 = response && response.status === 503;
            const isMaintenanceFlag = response.data && response.data.maintenance_mode === true;
            const isMaintenance = isStatus503 || isMaintenanceFlag;

            if (isMaintenance) {
                if (sessionStorage.getItem('maintenance_mode') !== 'true') {
                    sessionStorage.setItem('maintenance_mode', 'true');
                    window.location.href = '/maintenance';
                }
                return;
            }
            session.reset();
            return Promise.reject(e);
        });
    },
    reset: () => {
        request(true).get('/logout').then(() => console.log('SESSION: LOGGED OUT')).catch(() => console.log('SESSION: FAILED TO LOGOUT (Already logged out?)'));
        session.token = null;
        sessionStorage.removeItem('user-token');
        session.user = {
            id: null,
            name: null,
            permissions: [],
            bookmarks: [],
        };
        session.company = null;
        session.wholesaler = null;
        session.retailer = null;
    },
    refreshToken: () => {
        return request(true).post('/auth/refresh').then(e => {
            session.token = e.data.token;
            sessionStorage.setItem('user-token', e.data.token);
            return;
        }).catch(e => {
            session.reset();
            return Promise.reject();
        });
    },
    isAlive: () => {
        if (session.token) {
            if (session.user.name) {
                return true;
            } else {
                return session.fetch();
            }
        }

        return false;
    }
});

if (session.user.id === null && session.token !== null) {
    session.fetch();
}

export default session;

export const ProductContext = React.createContext(null);
